import { Link } from "react-router-dom";

import { Btn } from "../../lib/Btn";
import { Card } from "../../lib/Card";
import { Icon } from "../../lib/Icon";
import { Slats, SlattedDoor } from "../../lib/Slats";
import { useSeo } from "../../lib/useSeo";

export function NotFoundPage() {
  useSeo({
    title: "404 — Page not found · NestPlot",
    description: "That page isn't on this lot. Browse NestPlot by state, by competitor, or grab a free tool.",
    path: "/404",
    robots: "noindex",
  });
  return (
    <div className="mx-auto max-w-[1100px] px-5 lg:px-8 py-16 grid md:grid-cols-[1.4fr_1fr] gap-10 items-center">
      <div>
        <div className="font-mono text-[11px] text-sub tracking-[0.14em] uppercase">
          404 · door's locked
        </div>
        <h1 className="t-display-xl mt-3">
          That unit
          <br />
          <span className="text-accent">isn't on this lot.</span>
        </h1>
        <p className="text-sub text-lg mt-3 max-w-[480px]">
          The page you tried doesn't exist. It may have been moved, or you may have
          punched in the wrong code.
        </p>
        <div className="mt-6 flex gap-3 flex-wrap">
          <Link to="/">
            <Btn kind="primary" size="lg" iconRight={<Icon name="arrow-right" size={16} />}>
              Back to home
            </Btn>
          </Link>
          <Link to="/pricing">
            <Btn kind="ghost" size="lg">
              See pricing
            </Btn>
          </Link>
        </div>
      </div>
      <Card>
        <div className="bg-accent px-5 pt-3 pb-2">
          <Slats color="var(--on-accent)" opacity={0.55} height={10} />
        </div>
        <div className="p-6 flex justify-center">
          <SlattedDoor width={220} height={300} bands={14} />
        </div>
      </Card>
    </div>
  );
}
